import { useState, useEffect, useRef } from 'react';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

const useClienteDetalles = (id, tabActiva) => {
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const [customerdetails, setCustomers] = useState([]);
    const [agrupacionLicencias, setAgrupacionLicencias] = useState([]);
    const [tablaRegimenFiscal, settablaRegimenFiscal] = useState([]);
    const [tablaUsoCFDI, settablaUsoCFDI] = useState([]);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [nivelSoporte, setNivelSoporte] = useState([]);
    const [herramientas, setHerramientas] = useState([]);
    const [isDistribucion, setIsDistribucion] = useState(false);
    const [statusSolucion, setStatusSolucion] = useState([]);
    const [soporte, setSoporte] = useState([]);
    const [ordenes, setOrdenes] = useState([]);
    const [documentosCargados, setDocumentosCargados] = useState({
        docIDFoto: true,
        docCedFiscal: true,
        docCompDomicilio: true,
        docCartaMotivos: true
    });
    const [documentos, setDocumentos] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [cargandoTab, setCargandoTab] = useState(false);
    const [cargandoEstado, setCargandoEstado] = useState(false);
    const [cargandoFile, setCargandoFile] = useState(false);
    const [editar, setEditar] = useState(false);
    const [editando, setEditando] = useState(false);
    const [cargandoComboBoxSoporte, setCargandoComboBoxSoporte] = useState(false);
    const [licencias, setLicencias] = useState([]);
    const [polizas, setPolizas] = useState([]);
    const [dataFiles, setDataFiles] = useState({ DocFile: null });
    const [leadsVinculados, setLeadsVinculados] = useState([]);
    const [clienteActivityLogs, setClienteActivityLogs] = useState([]);
    const [clientesRepetidos, setClientesRepetidos] = useState([]);
    
    // Estado para controlar qué peticiones ya se hicieron
    const [dataFetched, setDataFetched] = useState({ info: false, catalogos: false, suscripciones: false, licencias: false, soporteTotals: false, leads: false, repetidos: false });
    const fetchingRef = useRef({ info: false, catalogos: false, licencias: false, soporteTotals: false, leads: false, repetidos: false, suscripciones: false });
    
    const [lastId, setLastId] = useState(id);
    if (id !== lastId) {
        setLastId(id);
        setCargando(true);
        setDataFetched({ info: false, catalogos: false, suscripciones: false, licencias: false, soporteTotals: false, leads: false, repetidos: false });
        fetchingRef.current = { info: false, catalogos: false, licencias: false, soporteTotals: false, leads: false, repetidos: false, suscripciones: false };
    }

    const [licenciasBaseMem, setLicenciasBaseMem] = useState([]);

    /**
     * Funciones individuales de obtención de datos
     */
    const fetchInfoGeneral = async (jDataSend) => {
        const resInfo = await fetch("/api/cliente/GetInfoGeneralCliente/", {
            method: 'POST',
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
            body: jDataSend
        });
        if (resInfo.ok) {
            const dataInfo = await resInfo.json();
            if (dataInfo.iResponseType === 1) {
                const infoGeneral = JSON.parse(dataInfo.detalles);
                const tInfoCliente = infoGeneral.table1 || infoGeneral.Table1 || Object.values(infoGeneral)[0] || [];
                const tDocumentos = infoGeneral.table2 || infoGeneral.Table2 || Object.values(infoGeneral)[1] || [];
                
                setCustomers(tInfoCliente[0]);
                setDocumentos(tDocumentos);
                for (let i = 0; i < tDocumentos.length; i++) {
                    if (tDocumentos[i].idTipoDoc == 1) setDocumentosCargados(d => ({ ...d, docIDFoto: false }));
                    if (tDocumentos[i].idTipoDoc == 2) setDocumentosCargados(d => ({ ...d, docCedFiscal: false }));
                    if (tDocumentos[i].idTipoDoc == 3) setDocumentosCargados(d => ({ ...d, docCompDomicilio: false }));
                    if (tDocumentos[i].idTipoDoc == 4) setDocumentosCargados(d => ({ ...d, docCartaMotivos: false }));
                }
                setDataFetched(prev => ({ ...prev, info: true }));
            } else {
                showErrorToast(dataInfo.vMessage || "Error en Info General");
            }
        } else {
            if (resInfo.status == 401) { setToken(null); location.href = ""; }
            showErrorToast(`Error ${resInfo.status}: ${resInfo.statusText}`);
        }
    };

    const fetchLicenciasYPolizas = async (jDataSend) => {
        const res = await fetch("/api/cliente/GetLicenciasYPolizasCliente/", { method: 'POST', headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, body: jDataSend });
        if (res.ok) {
            const data = await res.json();
            if (data.iResponseType === 1) {
                const modulos = JSON.parse(data.detalles);
                const tMod1 = modulos.table1 || modulos.Table1 || Object.values(modulos)[0] || [];
                const tMod2 = modulos.table2 || modulos.Table2 || Object.values(modulos)[1] || [];
                const tMod3 = modulos.table3 || modulos.Table3 || Object.values(modulos)[2] || [];
                setAgrupacionLicencias(tMod1);
                setLicenciasBaseMem(tMod2);
                setPolizas(tMod3);
                setDataFetched(prev => ({ ...prev, licencias: true }));
                return tMod2;
            } else { showErrorToast(data.vMessage || "Error en Licencias"); }
        } else { showErrorToast(`Error ${res.status}: ${res.statusText}`); }
        return [];
    };

    const fetchSoporteTotals = async (jDataSend) => {
        const res = await fetch("/api/cliente/GetSoporteTotalsCliente/", { method: 'POST', headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, body: jDataSend });
        if (res.ok) {
            const data = await res.json();
            if (data.iResponseType === 1) {
                const modulos = JSON.parse(data.detalles);
                const tMod = modulos.table1 || modulos.Table1 || Object.values(modulos)[0] || [];
                setSoporte(tMod);
                setDataFetched(prev => ({ ...prev, soporteTotals: true }));
            } else { showErrorToast(data.vMessage || "Error en Soporte Totals"); }
        } else { showErrorToast(`Error ${res.status}: ${res.statusText}`); }
    };

    const fetchLeads = async (jDataSend) => {
        const res = await fetch("/api/cliente/GetLeadsVinculadosCliente/", { method: 'POST', headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, body: jDataSend });
        if (res.ok) {
            const data = await res.json();
            if (data.iResponseType === 1) {
                const modulos = JSON.parse(data.detalles);
                const tMod = modulos.table1 || modulos.Table1 || Object.values(modulos)[0] || [];
                setLeadsVinculados(tMod);
                setDataFetched(prev => ({ ...prev, leads: true }));
            } else { showErrorToast(data.vMessage || "Error en Leads"); }
        } else { showErrorToast(`Error ${res.status}: ${res.statusText}`); }
    };

    const fetchRepetidos = async (jDataSend) => {
        const res = await fetch("/api/cliente/GetClientesRepetidosCliente/", { method: 'POST', headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, body: jDataSend });
        if (res.ok) {
            const data = await res.json();
            if (data.iResponseType === 1) {
                const modulos = JSON.parse(data.detalles);
                const tMod = modulos.table1 || modulos.Table1 || Object.values(modulos)[0] || [];
                if (tMod && tMod.length > 0 && tMod[0].vJsonClientesAkasiaRepetidos) {
                    try {
                        var clientesRepetidos = JSON.parse(tMod[0].vJsonClientesAkasiaRepetidos);
                        if (clientesRepetidos && Array.isArray(clientesRepetidos)) {
                            const idClienteTemp = parseInt(id, 10);
                            const newArray = clientesRepetidos.filter(e => e.idClienteAkasia !== idClienteTemp);
                            setClientesRepetidos(newArray);
                        }
                    } catch (e) {
                        console.error("Error al parsear clientes repetidos", e);
                    }
                }
                setDataFetched(prev => ({ ...prev, repetidos: true }));
            } else { showErrorToast(data.vMessage || "Error en Clientes Repetidos"); }
        } else { showErrorToast(`Error ${res.status}: ${res.statusText}`); }
    };

    const fetchCatalogos = async (jDataSend) => {
        const resCatalogos = await fetch("/api/cliente/GetCatalogosCliente/", {
            method: 'POST',
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
            body: jDataSend
        });
        if (resCatalogos.ok) {
            const dataCatalogos = await resCatalogos.json();
            if (dataCatalogos.iResponseType === 1) {
                const catalogos = JSON.parse(dataCatalogos.detalles);
                const tCat2 = catalogos.table2 || catalogos.Table2 || Object.values(catalogos)[0] || [];
                const tCat3 = catalogos.table3 || catalogos.Table3 || Object.values(catalogos)[1] || [];
                const tCat4 = catalogos.table4 || catalogos.Table4 || Object.values(catalogos)[2] || [];
                const tCat5 = catalogos.table5 || catalogos.Table5 || Object.values(catalogos)[3] || [];

                settablaRegimenFiscal(tCat2);
                settablaUsoCFDI(tCat3);
                setCountries(tCat4);
                setStates(tCat5);
                setDataFetched(prev => ({ ...prev, catalogos: true }));
            } else {
                showErrorToast(dataCatalogos.vMessage || "Error en Catálogos");
            }
        } else {
            if (resCatalogos.status == 401) { setToken(null); location.href = ""; }
            showErrorToast(`Error ${resCatalogos.status}: ${resCatalogos.statusText}`);
        }
    };

    const fetchSuscripciones = async (jDataSend, currentLicBase) => {
        const resSus = await fetch("/api/cliente/GetSuscripcionesLicenciasByCliente/", {
            method: 'POST',
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
            body: jDataSend
        });
        if (resSus.ok) {
            const dataSus = await resSus.json();
            if (dataSus.iResponseType === 1) {
                var suscripcionesRaw = dataSus.detalles ? JSON.parse(dataSus.detalles) : null;
                var firstKey = suscripcionesRaw ? Object.keys(suscripcionesRaw)[0] : null;
                var suscripciones = suscripcionesRaw && firstKey ? suscripcionesRaw[firstKey] : [];

                if (currentLicBase && currentLicBase.length > 0) {
                    var licenciasMerged = currentLicBase.map(lic => {
                        const susInfo = suscripciones.find(s => s.idLicencia === lic.idLicencia) || {};
                        return {
                            ...lic,
                            idSuscripcion: susInfo.idSuscripcion || null,
                            bIsActiveSuscripcion: susInfo.bIsActiveSuscripcion || null,
                            dTotal: susInfo.dTotal || null,
                            dFechaVenta: susInfo.dFechaVenta || null,
                            vMoneda: susInfo.vMoneda || null,
                            dImporte: susInfo.dImporte || null,
                            dDescuento: susInfo.dDescuento || null,
                            dIVA: susInfo.dIVA || null,
                            dCantidad: susInfo.dCantidad || null,
                            bTieneSuscripcionPendiente: susInfo.bTieneSuscripcionPendiente || 0
                        };
                    });
                    setLicencias(licenciasMerged);
                }
                setDataFetched(prev => ({ ...prev, suscripciones: true }));
            } else {
                showErrorToast(dataSus.vMessage || "Error Suscripciones");
            }
        } else {
            if (resSus.status == 401) { setToken(null); location.href = ""; }
            showErrorToast(`Error ${resSus.status}: ${resSus.statusText}`);
        }
    };

    const loadDataForTab = async (tabName, force = false) => {
        if (!id) return;
        const isInitialLoad = !dataFetched.info;
        if (isInitialLoad) {
            setCargando(true);
        } else {
            setCargandoTab(true);
        }
        var jDataSend = JSON.stringify({ idClienteAkasia: id });
        
        try {
            if (tabName === 'general' || tabName === 'ordenesydocumentos') {
                const promises = [];
                if ((force || !dataFetched.info) && !fetchingRef.current.info) { fetchingRef.current.info = true; promises.push(fetchInfoGeneral(jDataSend)); }
                if ((force || !dataFetched.catalogos) && !fetchingRef.current.catalogos) { fetchingRef.current.catalogos = true; promises.push(fetchCatalogos(jDataSend)); }
                if ((force || !dataFetched.licencias) && !fetchingRef.current.licencias) { fetchingRef.current.licencias = true; promises.push(fetchLicenciasYPolizas(jDataSend)); }
                if ((force || !dataFetched.soporteTotals) && !fetchingRef.current.soporteTotals) { fetchingRef.current.soporteTotals = true; promises.push(fetchSoporteTotals(jDataSend)); }
                if ((force || !dataFetched.leads) && !fetchingRef.current.leads) { fetchingRef.current.leads = true; promises.push(fetchLeads(jDataSend)); }
                if ((force || !dataFetched.repetidos) && !fetchingRef.current.repetidos) { fetchingRef.current.repetidos = true; promises.push(fetchRepetidos(jDataSend)); }
                await Promise.all(promises);
            }
            if (tabName === 'servicioscontratados') {
                const promises = [];
                if ((force || !dataFetched.info) && !fetchingRef.current.info) { fetchingRef.current.info = true; promises.push(fetchInfoGeneral(jDataSend)); }
                
                let licBase = licenciasBaseMem;
                if ((force || !dataFetched.licencias) && !fetchingRef.current.licencias) {
                    fetchingRef.current.licencias = true; 
                    licBase = await fetchLicenciasYPolizas(jDataSend);
                }
                
                if ((force || !dataFetched.suscripciones) && !fetchingRef.current.suscripciones) {
                    fetchingRef.current.suscripciones = true;
                    promises.push(fetchSuscripciones(jDataSend, licBase));
                }
                await Promise.all(promises);
            }
        } catch (error) {
            if (error.message === 'Unauthorized') { setToken(null); location.href = ""; }
            else { showErrorToast('Hubo un problema al cargar: ' + error.message); }
        } finally {
            setCargando(false);
            setCargandoTab(false);
        }
    };

    // Efecto para escuchar la pestaña activa y cargar sus datos
    useEffect(() => {
        if (tabActiva && id) {
            loadDataForTab(tabActiva);
        }
    }, [tabActiva, id]);

    // Exponer la función para que el componente padre pueda forzar la recarga
    const getinformaciondetalladaclientebyid = () => loadDataForTab(tabActiva, true);

    /**
     * llena el combobox para el soporte tecnico
     */
    const obtenerComboBoxSoporteTecnico = async () => {
        setCargandoComboBoxSoporte(true);

        try {
            const response = await fetch("/api/soportetecnico/ObtenerComboBoxesRegistroSoporte/", {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                setNivelSoporte(data['table1']);
                setHerramientas(data['table2']);
                setStatusSolucion(data['table3']);
            } else {
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Hubo un problema al obtener información de soporte técnico: ' + error.message);
        } finally {
            setCargandoComboBoxSoporte(false);
        }
    };

    /**
     * muestra los estados
     * @param {any} e
     */
    const mostrarEstados = async (e) => {
        setCargandoEstado(true);

        try {
            const response = await fetch("/api/cliente/GetStatesByCountry/?vCountryName=" + encodeURIComponent(e), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                setStates(data);
            } else {
                setStates([]);
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            setStates([]);
            showErrorToast('Hubo un problema al obtener los estados: ' + error.message);
        } finally {
            setCargandoEstado(false);
        }
    };

    /**
     * edita la info del cliente
     * @param {any} key
     * @param {any} values
     */
    const editarInfoCliente = async (key, values) => {
        console.log('=== editarInfoCliente llamado ===');
        console.log('ID Cliente:', key);
        console.log('Values:', values);

        setEditando(true);

        try {
            const response = await fetch("/api/cliente/updatecliente/?key=" + key + "&values=" + encodeURIComponent(values), {
                method: 'PUT',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            console.log('Response status:', response.status);
            console.log('Response OK:', response.ok);

            if (response.ok) {
                const data = await response.json();
                console.log('Response data:', data);

                if (data.iResponseType == 1) {
                    const objDetalles = JSON.parse(data.detalles)
                    console.log('Detalles actualizados:', objDetalles);
                    setCustomers(objDetalles.table2[0])
                    setEditar(false);
                    setEditando(false);
                    return { success: true, message: 'Se han guardado los datos correctamente' };
                } else {
                    console.error('Error en response:', data.vMessage);
                    showErrorToast(data.vMessage);
                    setEditando(false);
                    return { success: false };
                }
            } else {
                setStates([]);
                setEditando(false);
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
                return { success: false };
            }
        } catch (error) {
            console.error('Error en fetch:', error);
            showErrorToast('Hubo un problema al actualizar el cliente: ' + error.message);
            setEditando(false);
            return { success: false };
        }
    };

    /**
     * elimina un cliente
     * */
    const eliminarCliente = async () => {
        try {
            const response = await fetch("/api/cliente/EliminarCliente/?key=" + id, {
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType == 1) {
                    await getinformaciondetalladaclientebyid();
                    return { success: true, message: data.vMessage || 'Cliente eliminado correctamente' };
                } else {
                    showErrorToast(data.vMessage || 'No se pudo eliminar el cliente');
                    return { success: false };
                }
            } else {
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
                return { success: false };
            }
        } catch (error) {
            console.error('Error en eliminarCliente:', error);
            showErrorToast(error.message || 'Error desconocido al eliminar el cliente');
            return { success: false };
        }
    };

    /**
     * registra el soporte tecnico
     * @param {any} values
     */
    const registrarSoporteTecnico = async (values) => {
        try {
            const response = await fetch("/api/soportetecnico/RegistrarSoporteTecnico/?values=" + encodeURIComponent(values), {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                setEditar(false);
                await getinformaciondetalladaclientebyid();
                return { success: true, message: 'Se han guardado los datos correctamente' };
            } else {
                setStates([]);
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
                return { success: false };
            }
        } catch (error) {
            showErrorToast('Hubo un problema al registrar el soporte técnico: ' + error.message);
            return { success: false };
        }
    };

    /**
     * combina la información de 2 clientes en uno solo para evitar tener clientes repetidos
     */
    const combinarClientes = async (idClienteAkasiaACombinar) => {
        var jDataSend = {};
        jDataSend.idClienteAkasia = customerdetails.idClienteAkasia
        jDataSend.idClienteAkasiaACombinar = idClienteAkasiaACombinar

        try {
            const response = await fetch("/api/cliente/CombinarClientes/", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType == 1) {
                    await getinformaciondetalladaclientebyid();
                    showSuccessToast('Clientes combinados exitosamente');
                    return { success: true };
                } else {
                    showErrorToast(data.vMessage);
                    return { success: false };
                }
            } else {
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
                return { success: false };
            }
        } catch (error) {
            showErrorToast('Hubo un problema al combinar los clientes: ' + error.message);
            return { success: false };
        }
    };

    //Enviar Archivo DocFile
    const onSubmitDocFile = async (idTipoDoc) => {
        if (dataFiles.DocFile == null || dataFiles.DocFile.length == 0) {
            showErrorToast('Es obligatorio subir un documento para enviar');
            return { success: false };
        }

        setCargandoFile(true);

        var data = new FormData()
        data.append('DocFile', dataFiles.DocFile);
        data.append('idClienteAkasia', id);
        data.append('idTipoDoc', idTipoDoc)

        try {
            const response = await fetch("/api/distribuidor/SubirDocFile", {
                method: 'POST',
                body: data,
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });

            if (response.ok) {
                const data = await response.json();
                setDocumentos(data);

                setDocumentosCargados({
                    docCompDomicilio: true,
                    docCartaMotivos: true,
                    docCedFiscal: true,
                    docIDFoto: true
                });

                for (let i = 0; i < data.length; i++) {
                    if (data[i].idTipoDoc == 1)
                        setDocumentosCargados(documentosCargados => { return { ...documentosCargados, docIDFoto: false } })
                    if (data[i].idTipoDoc == 2)
                        setDocumentosCargados(documentosCargados => { return { ...documentosCargados, docCedFiscal: false } })
                    if (data[i].idTipoDoc == 3)
                        setDocumentosCargados(documentosCargados => { return { ...documentosCargados, docCompDomicilio: false } })
                    if (data[i].idTipoDoc == 4)
                        setDocumentosCargados(documentosCargados => { return { ...documentosCargados, docCartaMotivos: false } })
                }

                showSuccessToast('Documento cargado exitosamente');
                setDataFiles({ DocFile: null })
                return { success: true };
            } else {
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
                return { success: false };
            }
        } catch (error) {
            showErrorToast('Hubo un problema al subir el documento: ' + error.message);
            return { success: false };
        } finally {
            setCargandoFile(false);
        }
    };

    return {
        // Estados
        customerdetails,
        agrupacionLicencias,
        tablaRegimenFiscal,
        tablaUsoCFDI,
        countries,
        states,
        nivelSoporte,
        herramientas,
        isDistribucion,
        setIsDistribucion,
        statusSolucion,
        soporte,
        ordenes,
        setOrdenes,
        documentosCargados,
        setDocumentosCargados,
        documentos,
        cargando,
        cargandoEstado,
        cargandoFile,
        editar,
        setEditar,
        editando,
        cargandoComboBoxSoporte,
        licencias,
        polizas,
        dataFiles,
        setDataFiles,
        leadsVinculados,
        setLeadsVinculados,
        clienteActivityLogs,
        setClienteActivityLogs,
        clientesRepetidos,

        // Métodos
        getinformaciondetalladaclientebyid,
        obtenerComboBoxSoporteTecnico,
        mostrarEstados,
        editarInfoCliente,
        eliminarCliente,
        registrarSoporteTecnico,
        combinarClientes,
        onSubmitDocFile,
        cargandoTab
    };
};

export default useClienteDetalles;
